export const RESET_PASSWORD_TAG_NAME = 'tm-bo-reset-password';
